<template>
  <DefaultPage>
    <FilterMain
      v-model="filterQuery"
      @input="debouncedSearch"
      @clear="clearInputSearch"
    >
      <FilterBtn
        type="button"
        class="filter-btn"
        :active-filters="activeFilters"
        @click="filterModalVisible = true"
      />
      <button
        type="button"
        class="help-link"
        :class="{ active: showTutorialOnClick }"
        @click="showTutorialOnClick"
      >
        <div class="icon">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.29 13.29C9.247 13.3375 9.20693 13.3876 9.17 13.44C9.13216 13.4957 9.10189 13.5563 9.08 13.62C9.05117 13.6767 9.03095 13.7374 9.02001 13.8C9.0151 13.8666 9.0151 13.9334 9.02001 14C9.01663 14.1312 9.04402 14.2613 9.10001 14.38C9.14492 14.5041 9.21657 14.6168 9.30989 14.7101C9.40321 14.8034 9.51591 14.8751 9.64001 14.92C9.75971 14.9729 9.88913 15.0002 10.02 15.0002C10.1509 15.0002 10.2803 14.9729 10.4 14.92C10.5241 14.8751 10.6368 14.8034 10.7301 14.7101C10.8234 14.6168 10.8951 14.5041 10.94 14.38C10.9844 14.2584 11.0048 14.1294 11 14C11.0008 13.8684 10.9755 13.7379 10.9258 13.6161C10.876 13.4943 10.8027 13.3834 10.71 13.29C10.617 13.1963 10.5064 13.1219 10.3846 13.0711C10.2627 13.0203 10.132 12.9942 10 12.9942C9.86799 12.9942 9.73729 13.0203 9.61543 13.0711C9.49357 13.1219 9.38297 13.1963 9.29 13.29ZM10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433284 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7363 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM10 18C8.41775 18 6.87104 17.5308 5.55544 16.6518C4.23985 15.7727 3.21447 14.5233 2.60897 13.0615C2.00347 11.5997 1.84504 9.99113 2.15372 8.43928C2.4624 6.88743 3.22433 5.46197 4.34315 4.34315C5.46197 3.22433 6.88743 2.4624 8.43928 2.15372C9.99113 1.84504 11.5997 2.00346 13.0615 2.60896C14.5233 3.21447 15.7727 4.23984 16.6518 5.55544C17.5308 6.87103 18 8.41775 18 10C18 12.1217 17.1572 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18ZM10 5C9.47307 4.99966 8.95534 5.13812 8.49891 5.40144C8.04249 5.66476 7.66347 6.04366 7.4 6.5C7.32765 6.61382 7.27907 6.7411 7.25718 6.87418C7.23529 7.00726 7.24055 7.14339 7.27263 7.27439C7.30472 7.40538 7.36297 7.52854 7.44389 7.63643C7.52481 7.74433 7.62671 7.83475 7.74348 7.90224C7.86024 7.96974 7.98945 8.01292 8.12334 8.02918C8.25722 8.04544 8.39301 8.03445 8.52254 7.99688C8.65207 7.9593 8.77266 7.89591 8.87705 7.81052C8.98145 7.72513 9.06749 7.6195 9.13 7.5C9.21811 7.3474 9.34497 7.22078 9.49775 7.13298C9.65053 7.04518 9.82379 6.9993 10 7C10.2652 7 10.5196 7.10536 10.7071 7.29289C10.8946 7.48043 11 7.73478 11 8C11 8.26522 10.8946 8.51957 10.7071 8.70711C10.5196 8.89464 10.2652 9 10 9C9.73479 9 9.48043 9.10536 9.2929 9.29289C9.10536 9.48043 9 9.73478 9 10V11C9 11.2652 9.10536 11.5196 9.2929 11.7071C9.48043 11.8946 9.73479 12 10 12C10.2652 12 10.5196 11.8946 10.7071 11.7071C10.8946 11.5196 11 11.2652 11 11V10.82C11.6614 10.58 12.2174 10.1152 12.5708 9.50687C12.9242 8.89851 13.0525 8.18529 12.9334 7.49189C12.8143 6.79849 12.4552 6.16902 11.919 5.71352C11.3828 5.25801 10.7035 5.00546 10 5Z"
              fill="#878B9D"
            />
          </svg>
        </div>
        <span>Hjälp</span>
      </button>
    </FilterMain>

    <div class="applications-view-wrapper">
      <div v-if="isLoadingApps" class="loading-wrapper">
        <BaseLoadingSpinner :with-overlay="false" :size="60" />
      </div>
      <template v-else>
        <section class="applications-wrapper">
          <SwapApplicationsLane
            title="Inkommande"
            status="new"
            :applications="applicationsNew"
            :container-style="{
              opacity: 0.5
            }"
          />
          <Tooltip position="top" step="incoming"></Tooltip>

          <SwapApplicationsLane
            title="Fatta beslut"
            status="waiting"
            :applications="applicationsWaiting"
          />
          <Tooltip position="top" step="pending"></Tooltip>

          <SwapApplicationsLane
            title="Avslutade"
            status="handled"
            :applications="applicationsClosed"
          />
          <Tooltip
            position="top"
            step="completed"
            btn-text="Tack, jag förstår"
            :show-arrow="false"
          ></Tooltip>
        </section>
      </template>
      <router-view />
      <FilterModal
        v-if="filterModalVisible"
        :apps="filteredApps"
        @close="filterModalVisible = false"
      />
    </div>
  </DefaultPage>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import debounce from 'lodash.debounce';

import statusTypes from '@/utils/statusTypes';
import SwapApplicationsLane from '@/components/SwapApplicationsLane.vue';
import FilterMain from '@/components/FilterMain.vue';
import FilterModal from '@/components/FilterModal.vue';
import BaseLoadingSpinner from '@/components/BaseLoadingSpinner.vue';
import Tooltip from '@/components/Tooltip.vue';
import DefaultPage from '@/components/DefaultPage.vue';
import FilterBtn from '@/components/FilterBtn.vue';

export default {
  components: {
    SwapApplicationsLane,
    FilterMain,
    BaseLoadingSpinner,
    FilterModal,
    Tooltip,
    DefaultPage,
    FilterBtn
  },
  beforeRouteUpdate(to) {
    this.maybeClearInputSearch(to.path);
  },
  beforeRouteLeave(to) {
    //Leaving to new route and unmounting
    this.maybeClearInputSearch(to.path);
  },
  data() {
    return {
      filterQuery: this.$store.state.applications.filter || '',
      filterModalVisible: false
    };
  },

  computed: {
    ...mapGetters({
      filteredApps: 'applications/filteredApps',
      activeFilters: 'applications/activeFilters'
    }),
    ...mapState('applications', ['isLoadingApps', 'apps']),
    applicationsNew() {
      if (!this.filteredApps) {
        return [];
      }
      return this.filteredApps.filter(x => x.status === statusTypes.INCOMING);
    },

    applicationsWaiting() {
      if (!this.filteredApps) {
        return [];
      }
      return this.filteredApps.filter(x => x.status === statusTypes.READY);
    },

    applicationsClosed() {
      if (!this.filteredApps) {
        return [];
      }
      const closedApps = [
        statusTypes.APPROVED,
        statusTypes.REJECTED,
        statusTypes.CLOSED,
        statusTypes.ABORTED
      ];
      return this.filteredApps.filter(x => closedApps.includes(x.status));
    }
  },

  async created() {
    this.debouncedSearch = debounce(this.search, 300);
    await this.loadApplications();
    // Ladda arkivet i bakgrunden så vi kan räkna matchningar i andra vyn
    this.fetchRemovedApps();
    const firstAppId = this.apps?.[0]?.id;
    if (firstAppId) {
      this.fetchLandlordUsersWithUnassigned(firstAppId);
    }
  },
  methods: {
    ...mapActions({
      fetchApps: 'applications/fetchApps',
      fetchRemovedApps: 'applications/fetchRemovedApps',
      fetchLandlordUsersWithUnassigned:
        'applications/fetchLandlordUsersWithUnassigned'
    }),
    ...mapMutations({
      setFilter: 'applications/setFilter',
      resetFirstPartOfTooltipsArray: 'app/resetFirstPartOfTooltipsArray'
    }),
    maybeClearInputSearch(path) {
      // Behåll sökningen inom byten-modulen (alla/arkiv)
      if (!path.includes('byten')) {
        this.clearInputSearch();
      }
    },
    clearInputSearch() {
      this.filterQuery = '';
      this.debouncedSearch.cancel();
      this.search('');
    },
    async loadApplications() {
      await this.fetchApps();
    },
    search(query) {
      this.setFilter(query);
    },
    showTutorialOnClick() {
      this.resetFirstPartOfTooltipsArray();
    }
  }
};
</script>

<style scoped>
.help-link {
  padding: 0;
  text-decoration: none;
  color: #878b9d;
  font-weight: 600;
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: clamp(1.2rem, 0.8vw, 1.4rem);
  gap: 5px;
}

.help-link:hover {
  color: var(--color-blue);
}

.help-link:hover svg path {
  fill: var(--color-blue) !important;
}
.applications-wrapper {
  display: flex;
  flex-direction: row;
  height: 100%;
  max-width: 1080px;
}

.applications-view-wrapper {
  flex: 1;
  margin-left: 20px;
}

.loading-wrapper {
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.6);
}
</style>
